<template>
	<div style="width: 100%">
		<div>
			<v-tabs v-model="tab">
				<v-tab
					v-for="(n, i) in tabs"
					:to="'#' + n.value"
					:key="i+1"
				>
					{{n.name}}

				</v-tab>
				<v-tab-item
					v-for="(item, i) in tabs"
					:id="item.value"
					:key="i"
				>
					<v-card flat>
						<v-card-text>
							<v-layout>
								<v-flex md5>
									<Datepicker
										v-model="dateNow.start"
										:label="$t('workers.date_start')"
									/>
								</v-flex>
								<v-flex md5>
									<Datepicker
										v-model="dateNow.end"
										:label="$t('workers.date_start')"
									/>
								</v-flex>
								<v-flex md2>
									<v-btn @click="getByDate">
										{{$t('common.find')}}
									</v-btn>
								</v-flex>
								<v-flex md2>
									<DownloadExel
										:is-loading="isDownload"
										:file="reportNow"
										@load="loadReport"
										@onClear="clear"
										:textButton="$t('workers.export_finance_report')"
									/>
								</v-flex>
							</v-layout>
							<components
								:is="item.component"
							/>
						</v-card-text>
					</v-card>
				</v-tab-item>
			</v-tabs>
		</div>
	</div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import MainReport from './MainReport'
import UserReport from './UserReport'
import WorkerReport from './WorkerReport'
import Datepicker from '../../components/DatePicker'
import DownloadExel from '../../components/DownloadExel'
import { HEADERS_TABLE_MAIN_REPORTS } from '../../constants'
import { HEADERS_TABLE_USER_REPORTS } from '../../constants'
import { HEADERS_TABLE_WORKER_REPORTS } from '../../constants'
import {localeHeadersWorkers} from "../../utils/helpers";

export default {
	components: {
		Datepicker,
		DownloadExel
	},
	data: vm => ({
		search: '',
		tab: vm.$route.hash.replace(/^#/, '') || 'all',
		active: true,
		tabs: [
			{
				name: vm.$t('reports.all'),
				component: MainReport,
				value: 'all',
			},
			{
				name: vm.$t('reports.users'),
				component: UserReport,
				value: 'users',
			},
			{
				name: vm.$t('reports.workers'),
				component: WorkerReport,
				value: 'workers',
			}
		]
	}),
	methods: {
		...mapActions({
			fetchAll: 'reports/fetchAll',
			fetchUsers: 'reports/fetchUsers',
			fetchWorkers: 'reports/fetchWorkers',
			exportReport: 'reports/exportReport'
		}),
		...mapMutations({
			clearReports: 'reports/setReports'
		}),
		clear(report) {
			const type = this.tab
			this.clearReports({ type, report })
		},
		loadReport() {
			const type = this.tab
			let headers = localeHeadersWorkers(
				HEADERS_TABLE_MAIN_REPORTS.filter(
					item => item.value != 'subtracted' &&
							item.value != 'actions'
				), this.$t)
			if(type == 'users') { headers = localeHeadersWorkers(HEADERS_TABLE_USER_REPORTS, this.$t) }
			if(type == 'workers') { headers = localeHeadersWorkers(HEADERS_TABLE_WORKER_REPORTS, this.$t) }
			this.exportReport({
				type: type,
				headers: headers.map(item => item.text),
			})
		},
		getByDate() {
			this.requests[this.tab]()
		}
	},
	created() {
		this.requests[this.tab]()
	},
	computed: {
		...mapState({
			date: ({ reports }) => reports.date,
			reports: ({ reports }) => reports.reports,
			isDownload: ({ reports }) => reports.isDownload
		}),
		requests() {
			return {
				all: this.fetchAll,
				users: this.fetchUsers,
				workers: this.fetchWorkers
			}
		},
		dateNow() {
			return this.date[this.tab]
		},
		reportNow() {
			return this.reports[this.tab]
		}
	},
	watch: {
		tab(next, prev) {
			if (next !== prev) {
				this.requests[next]()
			}
		}
	}
}
</script>
